import React from "react";
// import { Link } from "react-router-dom";
import Privacy from "../components/privacy";

const Footer = () => {
  return (
    <footer className="bg-red-800 text-white p-4 mt-8 flex flex-row-reverse w-full justify-evenly items-center xs:text-xs md:text-base">
      <p>
        <a href="#privacy">Privacy</a>
      </p>
      <p className="text-center">
        <span>2024 © MILARTE C.F.: 97952360150</span>
      </p>
      <p className="flex flex-col items-center">
        Per informazioni:
        <a href="mailto:info@milarte.it" className="underline">
          info@milarte.it
        </a>
        <a href="mailto:milarte.mi@pec.it" className="underline">
          milarte.mi@pec.it
        </a>
      </p>
      <div className="text-center">
        <p>MilArte Via Giovanni Scheiwiller, 7</p>
        <p>20139 Milano</p>
      </div>
    </footer>
  );
};

export default Footer;
